import clsx from 'clsx';
import { FC } from 'react';
import { IframeStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import styles from './styles.module.css';

export const Iframe: FC<{ blok: IframeStoryblok }> = ({ blok }) => {
  return (
    <Container className={clsx(!blok.height && styles.noHeight)}>
      <iframe src={blok.link} className={styles.iframe} height={blok?.height} />
    </Container>
  );
};
